import { ReactElement } from 'react';
import {
  BarChartIcon,
  BellIcon,
  Buildings2Icon,
  CogIcon,
  FileTextIcon,
  HandshakeIcon,
  HeartIcon,
  HouseIcon,
  NewspaperIcon,
  PersonGroupIcon,
  ShieldIcon,
  ShieldLockIcon,
  TasklistIcon,
} from '@navikt/aksel-icons';
import { AkselIcons } from '../../utils/SideBarRoutes';

// Størrelsen settes i CSS (Sidebar.module.css)
export const iconMap = {
  BarChartIcon: <BarChartIcon aria-hidden />,
  BellIcon: <BellIcon aria-hidden />,
  Buildings2Icon: <Buildings2Icon aria-hidden />,
  CogIcon: <CogIcon aria-hidden />,
  FileTextIcon: <FileTextIcon aria-hidden />,
  HandshakeIcon: <HandshakeIcon aria-hidden />,
  HeartIcon: <HeartIcon aria-hidden />,
  HouseIcon: <HouseIcon aria-hidden />,
  NewspaperIcon: <NewspaperIcon aria-hidden />,
  PersonGroupIcon: <PersonGroupIcon aria-hidden />,
  ShieldIcon: <ShieldIcon aria-hidden />,
  ShieldLockIcon: <ShieldLockIcon aria-hidden />,
  TasklistIcon: <TasklistIcon aria-hidden />,
} satisfies Partial<Record<AkselIcons, ReactElement>>;
